import React, {useState} from 'react'
import styled from "styled-components";


const ThumbContainer = styled.div`
display: ${(props) => (props.ishalf ? "none" : "inline-block")};
/*padding: ${(props) => (props.ishalf ? "0.3rem" : "0.1rem")};*/
width: ${(props) => (props.ishalf ? "48px" : "96px")};
height: 54px;
box-sizing: border-box;
    margin: 0.25rem;
    box-shadow: 0px 18px 46px rgba(16, 22, 26, 0.2), 0px 4px 8px rgba(16, 22, 26, 0.2), 0px 0px 0px rgba(16, 22, 26, 0.1);
& > img {
    opacity:0;
    ${props=>props.isloading?"":"opacity:1;"}
    transition: opacity 0.5s;
  max-width: 100%;
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
&.active > img {
  transform: scale3d(1.1, 1.1, 1);
  box-shadow: 0px 0px 10px #a1b1b5;
}
& > img:hover {
  box-shadow: 0 0 10px #666;
  transform: scale3d(1.3, 1.3, 1);
  z-index: 2;
}
`;

function Thumbnail(props) {
    const {thumb , index, activeThumb, handleClick} = props;
    const [isloading, setisloading] = useState(true);
    return (
        <ThumbContainer
        key={index}
        className={(index === activeThumb ? "active " : "")+(isloading?" bp3-skeleton":"")}
        ishalf={index === 0}
        isloading={isloading}
        onClick={() => handleClick(index)}
      >
        <img src={thumb} alt=""  onLoad = {()=>setisloading(false)}/>
      </ThumbContainer>
    )
}

export default Thumbnail
